import React from 'react';
import SheetModal, { sheetButtons } from '../common/SheetModal';
import { COLORS } from '../../styles/tokens';

const CHIPS = {
  ok:      { background: COLORS.successBg, color: COLORS.successText },
  pending: { background: COLORS.blueBg,    color: COLORS.blueText },
  missing: { background: COLORS.warningBg, color: COLORS.warningText },
  blocked: { background: COLORS.dangerBg,  color: COLORS.dangerText },
};

// Bunnark for «Dokumenter og godkjenning»: hvert punkt med status og hva som er neste steg.
// items kommer fra buildApprovalItems; onAction(key) kalles når en «neste steg»-knapp trykkes.
export default function ApprovalSheet({ items, onClose, onAction }) {
  return (
    <SheetModal onClose={onClose} label="Dokumenter og godkjenning">
      <h2 style={sheetButtons.title}>Dokumenter og godkjenning</h2>
      <p style={sheetButtons.text}>Dette må være på plass før du kan ta oppdrag, og hva som er neste steg.</p>
      <ul style={styles.list}>
        {items.map(item => (
          <li key={item.key} style={styles.item} aria-label={`${item.title}: ${item.statusLabel}`}>
            <div style={styles.head}>
              <span style={styles.title}>{item.title}</span>
              <span style={{ ...styles.chip, ...CHIPS[item.status] }}>{item.statusLabel}</span>
            </div>
            <div style={styles.nextLabel}>Neste steg</div>
            <p style={styles.next}>{item.next}</p>
            {item.action && (
              <button type="button" style={styles.action} onClick={() => onAction(item.action.key)}>
                {item.action.label}
              </button>
            )}
          </li>
        ))}
      </ul>
      <button type="button" style={sheetButtons.ghost} onClick={onClose}>Lukk</button>
    </SheetModal>
  );
}

const styles = {
  list:      { listStyle: 'none', margin: '0 0 8px', padding: 0 },
  item:      { padding: '14px 0', borderBottom: `1px solid ${COLORS.border}` },
  head:      { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 },
  title:     { fontWeight: 700, fontSize: 15, color: COLORS.textDark },
  chip:      { borderRadius: 20, padding: '3px 10px', fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap' },
  nextLabel: { fontSize: 11, fontWeight: 700, color: COLORS.textLight, textTransform: 'uppercase', letterSpacing: '0.04em', marginTop: 8 },
  next:      { fontSize: 14, color: COLORS.textMid, lineHeight: 1.45, margin: '2px 0 0' },
  action:    { marginTop: 10, height: 40, padding: '0 18px', borderRadius: 20, border: 'none', background: COLORS.accent, color: '#1a1a2e', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
};
